<template>
    <div class="contribution-status">
        <b-card no-body class="p-3">
            <b-row>
                <b-col cols="12" lg="4" class="border-right">
                    <div class="mb-3">
                        <p class="text-xs text-muted">Total Contribution Amount</p>
                        <h3>RM {{ 80000 | moneyFormatter }}</h3>
                    </div>
                    <div class="mb-3">
                        <p class="text-xs text-muted">Total UTD Profit</p>
                        <h3 class="text-success">RM {{ 9600 | moneyFormatter }}</h3>
                    </div>
                    <div class="mb-3">
                        <p class="text-xs text-muted">Total Contribution Amount</p>
                        <h3 class="text-danger">- RM {{ 2400 | moneyFormatter }}</h3>
                    </div>
                </b-col>
                <b-col cols="12" lg="8">
                    <div id="chart">
                        <apexchart type="donut" :options="chartOptions" :series="series"></apexchart>
                    </div>
                </b-col>
            </b-row>
        </b-card>
    </div>
</template>
<script>
import VueApexCharts from 'vue-apexcharts'

export default {
    components: {
        "apexchart": VueApexCharts,
    },
    data() {
        return {
            series: [80, 20],
            chartOptions: {
                chart: {
                    type: 'donut',
                },
                labels: ['JV Fund 1.0-15% (RM)', 'Raya (RM)'],
                responsive: [{
                    breakpoint: 480,
                    options: {
                        chart: {
                            width: 200
                        },
                        legend: {
                            position: 'bottom'
                        }
                    }
                }]
            },
        }
    }
}
</script>